export const AVAILABLE_LANS = ["en", "zh", "zh-Hant", "kr", "jp", "es", "fr", "de"];
